import { NgModule } from '@angular/core';
import { ImageUploadComponent } from './image-upload/image-upload.component';
import { FileUploadComponent } from './file-upload/file-upload.component';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { StoreImageComponent } from './store-image/store-image.component';
import { MainSharedModule } from '../main-shared/main-shared.module';
import { CustomPaginationControlsComponent } from './custom-pagination-controls/custom-pagination-controls.component';
import { MatLegacyPaginatorModule as MatPaginatorModule } from '@angular/material/legacy-paginator';

@NgModule({
  declarations: [
    ImageUploadComponent,
    FileUploadComponent,
    StoreImageComponent,
    CustomPaginationControlsComponent,
  ],
  imports: [MatTooltipModule, MatPaginatorModule, MainSharedModule],
  exports: [
    ImageUploadComponent,
    FileUploadComponent,
    StoreImageComponent,
    MainSharedModule,
    CustomPaginationControlsComponent,
  ],
})
export class SharedModule {}
